import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TechQuestionVo } from 'src/app/models/questDeatilVo';
import { MessageService } from 'src/app/service/messageService';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-tech-questions-list',
  templateUrl: './tech-questions-list.component.html',
  styleUrls: ['./tech-questions-list.component.scss']
})
export class TechQuestionsListComponent implements OnInit {

  constructor(
    private router: Router,
    private http: HttpClient,
    private tostr:MessageService,
    public matDialog: MatDialog,
  ) { }

  displayColumns=["category","domain","link","tags","description","contentDetails","createdDate","action",]

  ngOnInit(): void {

    // let data = new TechQuestionVo();
    // data.category = "Category";
    // data.contentDetails = "content details";
    // data.description = "description"
    // data.domain = "domain";
    // data.link = "http://localhost:4200"
    // data.tags = ["esdefdf","sdfsdfd"]

    // this.dataSource.push(data);
    // this.dataSource.push(data);
    // this.dataSource.push(data);
    // this.dataSource.push(data);
    // this.dataSource.push(data);this.dataSource.push(data);
    // this.dataSource.push(data);
    this.getJobOpeningsList();
  }

  getIsAdmin():boolean {
    if(localStorage.getItem("userType")!= undefined && localStorage.getItem("userType") == "Admin") {
      return true;
    }
    return false;
  }

  
  getJobOpeningsListCall() {
    let url =   "https://tdnuf7xcgjqaeqfpohjmy3zvei0uhfoy.lambda-url.us-west-1.on.aws/";


    if (!this.getIsAdmin()) {
     
      if(localStorage.getItem("userId") != undefined) {

        let usrId = localStorage.getItem("userId");
        url = url+"?param1="+usrId;
      }
    }
    return this.http.get(url);
  }

  getJobOpeningsList() {
    // let id = "asasas"
    // this.loader.start(id);
    this.getJobOpeningsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;

       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);
        this.dataSource = listData;
        this.total = listData.length;
          // this.tostr.success("data retrived successfully")
          // this.loader.stop(id);
      });
  }

  total:number = 100;
  skip:number = 0;
  limit:number = 10;
  dataSource:TechQuestionVo[] =[];
  dialogRef: any;

  getList(event:any){
    this.skip = event.pageIndex * event.pageSize;
    this.limit = event.pageSize;
    console.log(this.skip )
    console.log(this.limit)
  }


  addTechQuestion(){
    this.router.navigateByUrl("techquestion/-1")
  }

  deleteQuestionCall(questId:any) {
    // TODO: Add Url here
    return this.http.get("https://6lhavjo4r7pvpb5emhfb5m5v4m0tgrmq.lambda-url.us-west-1.on.aws/?param1=" + questId);
  }

  editQuestion(id:any){
    this.router.navigateByUrl("techquestion/"+id)
  }

  deleteQuestion(id:any) {
    this.dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
      width: '300px',
      height: '200px',
      disableClose: true,
      data: {
        title: 'Delete Confirmation',
        subject: 'Are you sure you want to delete the Question permanently?',
        submitButton: 'Proceed',
        cancelButton: 'Cancel'
      }
    })
    this.dialogRef.afterClosed().subscribe((result: any) => {
      if(result) {
        this.deleteQuestionCall(id).subscribe(data => {
          let responce : any = data;
          this.tostr.success("Data Deleted Successfully");
          this.getJobOpeningsList();
       });
      }
    });
  }

}
